import styled from "styled-components";
import { colors } from "../../const/theme";

export const AboutWrapper = styled.div`
  background-color: #171819;
  box-shadow: 0 0 0 0 ${colors.white};
  padding: 120px 0;
  position: relative;
`;
